import { typedQueryClient, useTypedQuery } from "hooks";
import { DMSIDS } from "models";
import { DMSCapabilitiesQueryKeys } from "modules/DMSv3/Capabilities/queryKeys";

export const DEFAULT_SELECTED_DMS = [DMSIDS.KEYLOOP_MENUS, DMSIDS.KEYLOOP_JOBS, DMSIDS.WINCAR, DMSIDS.AUTOLINE, DMSIDS.EVA];

export const useSelectedDMSIds = () => useTypedQuery({ queryKey: DMSCapabilitiesQueryKeys.selectedDMSIds, initialData: DEFAULT_SELECTED_DMS });
export const setSelectedDMSIds = (dmsIds: number[]) => typedQueryClient.setQueryData(DMSCapabilitiesQueryKeys.selectedDMSIds, dmsIds);
